import { Flex, Switch } from "@repo/ping-design";
import { MISSING_VALUE } from "@repo/ping-react-js";
import "./DisplacementSection.scss";

export const DisplacementSection = ({
  section,
  isDisplacementMode,
  onClickDisplacement,
}: {
  section: any[];
  isDisplacementMode: boolean;
  onClickDisplacement: () => void;
}) => {
  return (
    <div className="DisplacementSection">
      <div className="DisplacementSection__Data">
        {section.map((field, ix) => {
          const isLastItem = ix === section.length - 1;
          return !isLastItem ? (
            <Flex
              key={field.k}
              direction="row"
              gap="3"
              align="center"
              className="DisplacementSection__Data__Maps"
            >
              <span className="DisplacementSection__Data__Maps__Label">
                {field.k}
              </span>
              <span className="DisplacementSection__Data__Maps__Value">
                {field.v || MISSING_VALUE}
              </span>
            </Flex>
          ) : (
            <Flex direction="row" justify="space-between">
              <Flex
                key={field.k}
                direction="row"
                gap="3"
                align="center"
                className="DisplacementSection__Data__Maps"
              >
                <span className="DisplacementSection__Data__Maps__Label">
                  {field.k}
                </span>
                <span className="DisplacementSection__Data__Maps__Value">
                  {field.v || MISSING_VALUE}
                </span>
              </Flex>
              <Switch
                label="Displacement"
                checked={isDisplacementMode}
                onChange={(c) => {
                  onClickDisplacement();
                }}
              />
            </Flex>
          );
        })}
      </div>
    </div>
  );
};
